<footer>
  <div>
    <p i18n>&copy; Alyseo{{copyright}} - Tous droits réservés</p>
  </div>
</footer>
